import { ReactElement } from "react"
import { CheckboxProps } from "./checkbox-props"
import * as S from './checkbox-style'

export function Checkbox ({ label, value, ...props }: CheckboxProps): ReactElement {
  return <S.Container>
    <S.Input {...props} type="checkbox" />
    <S.Label htmlFor={props.id}>{label}</S.Label>
  </S.Container>
}